const PATH_BACKGROUND_COLORS = {
  '/product/ai': 'bg-violet-900',
  '/game-changer': 'bg-violet-100',
} as const;

export const getFooterBackgroundColor = (path: string) => PATH_BACKGROUND_COLORS[path] ?? '';

const HIDE_FOOTER_PATTERN_PATHS = ['/control-shift', '/partners/channel'];

export const shouldHideFooterPatternOnPagePath = (path: string) => HIDE_FOOTER_PATTERN_PATHS.includes(path);
